module.exports = __webpack_public_path__ + "static/media/9DESA34.a4b25e3c.jpg";